import { MealGroupStudent } from '@/plugins/api'
import { chunk } from 'lodash'
import { countGroupStudents, listGroupStudents } from '@/store/mealConfig/helpers/groupStudents.js'

/**
 * Store thành viên nhóm đăng ký ăn.
 * fetchMembers liệt kê HẾT học sinh của nhóm (default suy từ student, custom từ bảng nối).
 * selectedStudent + addSelectedStudents phục vụ dialog "Thêm học sinh" (chọn nhiều HS).
 */
export default {
  namespaced: true,
  state: {
    students: [],
    selectedStudent: [],
    totalItems: 0,
    itemsPerPage: 10,
    pageText: '',
    loading: false
  },
  actions: {
    async addSelectedStudents({ state }, groupId) {
      const codes = state.selectedStudent.map(s => s.code).filter(Boolean)
      let errors = []
      for (const part of chunk(codes, 10)) {
        try {
          await MealGroupStudent.addStudentPack({ studentCodes: part, groupId })
        } catch (e) {
          errors.push(typeof e === 'string' ? e : e.message || 'Lỗi thêm học sinh')
        }
      }
      return errors
    },
    async fetchMembers({ commit, state }, { group, page = 1, itemsPerPage }) {
      commit('changeState', { loading: true })
      const limit = itemsPerPage || state.itemsPerPage
      const params = { _start: (page - 1) * limit, _limit: limit }
      const [totalItems, students] = await Promise.all([
        countGroupStudents(group),
        listGroupStudents(group, params)
      ])
      const pageStop = Math.min(page * limit, totalItems)
      commit('changeState', {
        students,
        totalItems,
        itemsPerPage: limit,
        pageText: `${totalItems ? (page - 1) * limit + 1 : 0}-${pageStop} trên ${totalItems}`,
        loading: false
      })
    },
    async addStudentPack(_, { studentCodes, groupId }) {
      return MealGroupStudent.addStudentPack({ studentCodes, groupId })
    },
    async remove(_, id) {
      return MealGroupStudent.remove(id)
    }
  },
  mutations: {
    changeState(state, obj) {
      Object.assign(state, obj)
    },
    setSelectedStudent(state, data) {
      state.selectedStudent = data
    }
  }
}
